import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import Base from './input-base';

var ZoomIn =
/*#__PURE__*/
function (_Base) {
  _inherits(ZoomIn, _Base);

  function ZoomIn() {
    var _this;

    _classCallCheck(this, ZoomIn);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ZoomIn).call(this));

    var a = _assertThisInitialized(_assertThisInitialized(_this));

    a._toggle = function () {
      a.isEnabled() && a.zoom();
    };

    return _this;
  }

  _createClass(ZoomIn, [{
    key: "getName",
    value: function getName() {
      return 'zoomInButton';
    }
  }, {
    key: "configure",
    value: function configure() {
      _get(_getPrototypeOf(ZoomIn.prototype), "configure", this).call(this);

      var a = this,
          b = a.config;
      b.stepZoom = b.stepZoom || 5.33, b.skipGraphics || a.setLinkedItem('button', a.createButton({
        icon: 'zoomInIcon',
        handlers: {
          click: a._toggle
        },
        tooltext: a.config.tooltext,
        state: 'activated'
      })), a.enable();
    }
  }, {
    key: "zoom",
    value: function zoom() {
      var a,
          b,
          c,
          d,
          e,
          f,
          g,
          h,
          i,
          j = this,
          k = {},
          l = j.config,
          m = l.hookFn,
          n = !1,
          o = Math.pow(10, l.zoomDecimalLimit) || 1;
      j.getFromEnv('animationManager').setAnimationState('zoom'), j.getFromEnv('axesObArr').forEach(function (p) {
        c = p.axis, a = c.getVisibleConfig(), b = Math.round((a.maxValue - a.minValue) / l.stepZoom * o) / o, b > Number.EPSILON && (p.stack.push(a), p.isY ? (f = a.minValue + b, g = a.maxValue - b) : (d = a.minValue + b, e = a.maxValue - b, k = j.constructor._getZoomInfo(d, e, c)), h = p.stack.length + 1, m && m(a.minValue, a.maxValue), i = c.setVisibleConfig(a.minValue + b, a.maxValue - b), n = n || i);
      }), n && j._raiseZoomEvents('zoomin', 'zoomedin', Object.assign(k, {
        level: h,
        startX: d,
        endX: e,
        startY: f,
        endY: g
      }));
    }
  }]);

  return ZoomIn;
}(Base);

export default ZoomIn;